import React from 'react';
import ReactWeather, { useOpenWeather } from 'react-open-weather';
import { JobDto } from 'src/api/FiretrolApiClient';

interface IWeatherCardProps {
  job: JobDto;
}

const customStyles = {
  fontFamily:
    '-apple-system, "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Open Sans", "Helvetica Neue", "Icons16", sans-serif',
  gradientStart: '#116faa',
  gradientMid: '#1484c9',
  gradientEnd: '#55b3ee',
  locationFontColor: '#FFF',
  todayTempFontColor: '#FFF',
  todayDateFontColor: '#B5DEF4',
  todayRangeFontColor: '#B5DEF4',
  todayDescFontColor: '#B5DEF4',
  todayInfoFontColor: '#B5DEF4',
  todayIconColor: '#FFF',
  forecastBackgroundColor: '#FFF',
  forecastSeparatorColor: '#DDD',
  forecastDateColor: '#777',
  forecastDescColor: '#777',
  forecastRangeColor: '#777',
  forecastIconColor: '#137cbd',
};

export const WeatherCard: React.FC<IWeatherCardProps> = ({ job }) => {
  // Handle location which can be an object with geo coordinates or a string
  const locationObj = typeof job.location === 'object' ? job.location : null;
  const locationLabel =
    typeof job.location === 'string' ? job.location : locationObj?.address;
  const { data, errorMessage } = useOpenWeather({
    key: import.meta.env.VITE_OPEN_WEATHER_API_KEY,
    lat: locationObj?.geo?.lat,
    lon: locationObj?.geo?.lng,
    lang: 'en',
    unit: 'imperial', // values are (metric, standard, imperial)
  });
  return (
    <>
      <ReactWeather
        theme={customStyles}
        isLoading={false}
        errorMessage={errorMessage}
        data={data}
        lang="en"
        locationLabel={locationLabel}
        unitsLabels={{ temperature: 'F', windSpeed: 'mph' }}
        showForecast
      />
    </>
  );
};
